exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".detail-image {\n    display: block;\n    width: 70%;\n    height: auto;\n    margin: 0px auto;\n}\n\n.book-detail-bottom {\n    padding-left: 4em;\n    padding-right: 4em;\n}\n\n.white-space-p {\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n}", ""]);

